import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { iconStyleMap } from './buttonClassNameConstants.js';
/** @deprecated */
export const ButtonInner = JSX((props) => {
    const { text, aboveText, appendLeft, appendRight, version = 'primary' } = props;
    const iconHideStyle = isWithText(props) && 'hidden lg:block';
    return (_jsxs("div", { className: style(buttonStyle(props), 'flex gap-xs'), children: [appendLeft ? (_jsx("div", { className: style(iconHideStyle, iconStyleMap[version]), children: appendLeft })) : null, isWithText(props) ? (_jsxs("div", { className: "whitespace-pre", children: [aboveText ? _jsx("div", { className: "text-xs font-light text-left", children: aboveText }) : null, _jsx("div", { className: `text-left ${aboveText ? 'text-s -mt-3xs' : 'text-l'}`, children: text })] })) : null, appendRight ? (_jsx("div", { className: style(iconHideStyle, iconStyleMap[version]), children: appendRight })) : null] }));
});
const buttonStyle = (props) => {
    const { version, aboveText, rounded } = props;
    if (version === 'link') {
        return '';
    }
    const withTextStyle = `${aboveText ? 'py-2.5 px-9' : 'py-4 px-9'}`;
    return style('group/btn items-center justify-center', isWithText(props) ? withTextStyle : 'h-12 w-12 m-auto', {
        'rounded-full': rounded,
    });
};
const isWithText = ({ text, aboveText, appendLeft }) => Boolean(text || aboveText || !appendLeft);
//# sourceMappingURL=ButtonInner.js.map